import { Routes } from '@angular/router';
import { LetterComponent } from './pages/letter/letter/letter.component';
import { AccomodationComponent } from './pages/accomodation/accomodation/accomodation.component';
import { FeedbackComponent } from './pages/feedback/feedback/feedback.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { ConfirmationSuccessComponent } from './pages/confirmation-success/confirmation-success.component';

export const routes: Routes = [
  { path: '', title: 'Offer', component: LetterComponent },
  {
    path: 'confirmation-success',
    component: ConfirmationSuccessComponent,
  },

  { path: 'feedback', title: 'Feedback', component: FeedbackComponent },
  {
    path: 'accommodation/:id',
    title: 'Accomodation',
    component: AccomodationComponent,
  },
  { path: 'error', component: ErrorPageComponent },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];
